import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { CREATE_DATA_MANAGEMENT_FILE_MUTATION } from "@/api/mutations/createDataManagementFile";

export interface CreateDataManagementFileParams {
  organizationId: string;
  file: File;
}

export interface CreateDataManagementFileReturn {
  loading: boolean;
  error: Error | null;
  data: {
    id?: string;
    name?: string;
    url?: string;
    createdAt?: number;
  } | null;
}

export const useCreateDataManagementFile = (): [
  (params: CreateDataManagementFileParams) => void,
  CreateDataManagementFileReturn,
] => {
  const [createDataManagementFileMutation, { loading, data, error }] =
    useMutation(CREATE_DATA_MANAGEMENT_FILE_MUTATION);

  const createDataManagementFile = useCallback(
    (params: CreateDataManagementFileParams) => {
      const { organizationId, file } = params;
      if (organizationId && file) {
        createDataManagementFileMutation({
          variables: {
            organizationId,
            file,
          },
        });
      }
    },
    [createDataManagementFileMutation],
  );

  const fileData = data?.createDataManagementFileMutation?.dataManagementFile;

  const returnData = {
    loading,
    error: error || null,
    data: fileData
      ? {
          id: fileData.id,
          name: fileData.name || undefined,
          url: fileData.url || undefined,
          createdAt: fileData.createdAt,
        }
      : null,
  };

  return [createDataManagementFile, returnData];
};
